import React from 'react';

import './index.scss';

interface CookieManagerProps {
  cookieDomain: string;
}

interface CookieManagerState {
  show: boolean;
}

export const CustommerTypeCookieName = 'buchbutler_cm';

export default class CookieManager extends React.Component<
  CookieManagerProps,
  CookieManagerState
> {
  constructor(props: any) {
    super(props);

    this.state = { show: false };
  }

  componentDidMount() {
    let newState = !this.hasCookie();
    if (this.state.show != newState) this.setState({ show: newState });

    let anyWin: any = window;

    anyWin.historyHelper.cookieBaner = this;
    let urlParams = new URLSearchParams(
      anyWin.historyHelper.browser.location.search,
    );

    if (
      urlParams.has('utm_campaign') ||
      urlParams.has('utm_source') ||
      urlParams.has('utm_medium')
    ) {
      if (anyWin.historyHelper.utm == undefined) {
        anyWin.historyHelper.utm = {
          utm_campaign: urlParams.get('utm_campaign'),
          utm_source: urlParams.get('utm_source'),
          utm_medium: urlParams.get('utm_medium'),
        };
      }
      if (this.hasCookie()) {
        this.persistUTM();
      }
    }
  }

  hasCookie() {
    let cookie = getCookie(CustommerTypeCookieName);
    let newState = cookie != '1' && cookie != '2';

    return !newState;
  }

  showBannerIntern() {
    this.setState({ show: true });
  }

  showBanner() {
    this.showBannerIntern();
  }

  persistUTM() {
    let cookieDomain = this.props.cookieDomain;

    let anyWin = window;
    if (
      anyWin.historyHelper != undefined &&
      anyWin.historyHelper.utm != undefined
    ) {
      let jsonUtm = JSON.stringify(anyWin.historyHelper.utm);
      setCookie('UTM', jsonUtm, 1, cookieDomain);
    }
  }

  render() {
    if (!this.state.show) {
      return null;
    }

    return (
      <div id="CookieManager">
        <div style={{ position: 'relative' }}>
          <div className="textContainer">
            <b>Einwilligung zu Cookies & Daten</b>
            <p>
              Auf dieser Website nutzen wir Cookies und vergleichbare Funktionen
              zur Verarbeitung von Endgeräteinformationen und personenbezogenen
              Daten. Die Verarbeitung dient der Einbindung von Inhalten,
              externen Diensten und Elementen Dritter, der statistischen
              Analyse/Messung, personalisierten Werbung sowie der Einbindung
              sozialer Medien. Je nach Funktion werden dabei Daten an Dritte
              weitergegeben und von diesen verarbeitet. Diese Einwilligung ist
              freiwillig, für die Nutzung unserer Website nicht erforderlich und
              kann jederzeit über das Icon links unten widerrufen werden.
              <br />
              <br />
              Um Ihnen als Kunden die richtigen Konditionen darstellen zu
              können, wählen Sie bitte beim jeweiligen Kästchen Ihre Zustimmung
              aus.
            </p>
            <div className="option">
              <span></span>
              <br />
              <br />
              <button
                className="none"
                onClick={() => {
                  this.setState({ show: false });
                }}
              >
                Ablehnen
              </button>
            </div>

            <div className="option">
              <span>Privat Kunde</span>
              <br />
              <br />
              <button
                onClick={() => {
                  let historyHelperModule: any = window.historyHelper;
                  let subAddress = historyHelperModule.browser.location;
                  let targetUrl =
                    'https://www.moluna.de' +
                    subAddress.pathname +
                    subAddress.search;
                  historyHelperModule.memory.push('/extern', targetUrl);
                }}
                className="privat"
              >
                Akzeptieren
              </button>
            </div>
            <div className="option">
              <span>Buchhändler</span>
              <br />
              <br />
              <button
                onClick={() => {
                  setCookie(
                    CustommerTypeCookieName,
                    2,
                    90,
                    this.props.cookieDomain,
                  );
                  this.persistUTM();
                  window.location.reload();
                }}
                className="b2b"
              >
                Akzeptieren
              </button>
            </div>
            {/* 
            <div className="option">
              <span>
                Firmenkunde
                <br />
                Behörde
              </span>
              <br />
              <button
                onClick={() => {
                  setCookie(
                    CustommerTypeCookieName,
                    1,
                    90,
                    this.props.cookieDomain,
                  );
                  this.persistUTM();
                  window.location.reload();
                }}
                className="b2b"
              >
                Akzeptieren
              </button>
            </div>
            */}
            <br style={{ clear: 'both' }} />
            <br />
            <div style={{ marginTop: '10px', margin: 'auto' }}></div>
          </div>
        </div>
      </div>
    );
  }
}

export function setCookie(cname, cvalue, exdays, domain) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = 'expires=' + d.toUTCString();
  let cookieText =
    cname + '=' + cvalue + ';' + expires + ';domain=' + domain + ';path=/';

  document.cookie = cookieText;
}

export function getCookie(cname) {
  let name = cname + '=';
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

export enum ConsentEnum {
  GoogleAnalytics,
  FB_pixel,
  Webgains,
  SENTRY,
}

export function hasConsent(name: ConsentEnum): boolean {
  //TODO: Implement COOKIE/Consens Logic
  if (name == ConsentEnum.SENTRY) return true;
  return false;
}
